<div class="driver-modal">
  <div class="sec_head">
    <h2>{{ 'Add' | translate }} {{ 'AttributeValue' | translate }}</h2>
  </div>
  <div class="modal-body">
    <form
      class="attribute-modal"
      [formGroup]="attributeValueFormGroup"
      (ngSubmit)="onSubmit()">
      <div class="form_feilds gap_m">
        <div class="form_group w_100">
          <mat-label class="required">{{ 'Label' | translate }}</mat-label>
          <mat-form-field>
            <input
              matInput
              type="text"
              formControlName="label"
              class="form_control" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              attributeValueFormGroup.controls['label'].hasError('required')
            ">
            {{ 'Label' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
        </div>
        <div class="form_group w_100">
          <mat-label class="required">{{ 'LabelAr' | translate }}</mat-label>
          <mat-form-field>
            <input
              matInput
              type="text"
              formControlName="label_ar"
              class="form_control" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              attributeValueFormGroup.controls['label_ar'].hasError('required')
            ">
            {{ 'LabelAr' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
        </div>
        <div
          class="form_group w_100"
          *ngIf="data.inputType === attributeType[0].value">
          <mat-label>{{ 'Value' | translate }}</mat-label>
          <mat-form-field>
            <input
              matInput
              formControlName="value"
              type="text"
              class="form_control" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              attributeValueFormGroup.controls['value'].hasError('required')
            ">
            {{ 'Value' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
        </div>
        <div
          class="form_group w_100"
          *ngIf="data.inputType === attributeType[0].value">
          <mat-label>{{ 'ValueAr' | translate }}</mat-label>
          <mat-form-field>
            <input
              matInput
              formControlName="value_ar"
              type="text"
              class="form_control"
              dir="rtl" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              attributeValueFormGroup.controls['value_ar'].hasError('required')
            ">
            {{ 'ValueAr' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
        </div>
        <div
          class="form_group w_100"
          *ngIf="data.inputType === attributeType[1].value">
          <mat-label>{{ 'Value' | translate }}</mat-label>
          <mat-form-field>
            <input
              matInput
              formControlName="value"
              type="number"
              class="form_control" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              attributeValueFormGroup.controls['value'].hasError('required')
            ">
            {{ 'Value' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
        </div>
        <div
          class="form_group w_100"
          *ngIf="data.inputType === attributeType[1].value">
          <mat-label>{{ 'ValueAr' | translate }}</mat-label>
          <mat-form-field>
            <input
              matInput
              formControlName="value_ar"
              type="number"
              class="form_control"
              dir="rtl" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              attributeValueFormGroup.controls['value_ar'].hasError('required')
            ">
            {{ 'ValueAr' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
        </div>
        <div
          class="form_group w_100"
          *ngIf="data.inputType === attributeType[2].value">
          <mat-label>{{ 'Value' | translate }}</mat-label>
          <mat-form-field>
            <input
              matInput
              formControlName="value"
              type="color"
              value="#000000"
              class="form_control" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              attributeValueFormGroup.controls['value'].hasError('required')
            ">
            {{ 'Value' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
        </div>
        <div
          class="form_group w_100"
          *ngIf="data.inputType === attributeType[2].value">
          <mat-label>{{ 'ValueAr' | translate }}</mat-label>
          <mat-form-field>
            <input
              matInput
              formControlName="value_ar"
              type="color"
              value="#000000"
              class="form_control"
              dir="rtl" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              attributeValueFormGroup.controls['value_ar'].hasError('required')
            ">
            {{ 'ValueAr' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
        </div>
      </div>
      <div class="submit_btn">
        <button class="btnn btn_primary" type="submit">
          {{ 'Submit' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
